import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";
import "./i18n";
import { AuthProvider } from "./components/Auth/AuthContext";
import { ThemeProvider } from "./components/ThemeContext";
import { CompanyProvider } from "./components/Company/CompanyContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <CompanyProvider>
      <AuthProvider>
        <BrowserRouter>
          <App />
          <ToastContainer position="top-right" autoClose={4000} closeOnClick pauseOnHover />
        </BrowserRouter>
      </AuthProvider>
    </CompanyProvider>
  </ThemeProvider>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
